import MobileObjectsList from './MobileObjectsList'

export default MobileObjectsList